'use client';
import PropTypes from 'prop-types';
import { deprecatedPropValues } from '../core/deprecated-prop-values.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * The type of callout
   * 'overlay' variant is deprecated
   * @default standard
   */ variant: deprecatedPropValues(PropTypes.oneOf([
        'standard',
        'overlay',
        'inverse'
    ]), [
        'overlay'
    ], 'Omit or use the `standard` variant instead.'),
    /**
   * @deprecated
   * This is deprecated without a replacement.
   *
   * The size variation
   * @default standard
   */ size: deprecatedProp(PropTypes.oneOf([
        'standard',
        'mini'
    ]), 'Sizing is now handled automatically by standardMode/compactMode'),
    /**
   * The visual style of the Callout
   * The 'foil', 'new' and 'announcement' skins are deprecated; use 'accent' instead
   * The 'discount' skin is deprecated; use 'promo' instead
   * The 'standard' skin is deprecated; use 'info' instead
   * @default info
   */ skin: deprecatedPropValues(PropTypes.oneOf([
        'standard',
        'announcement',
        'accent',
        'discount',
        'holiday',
        'error',
        'info',
        'new',
        'foil',
        'warning',
        'success',
        'help',
        'promo'
    ]), [
        'standard',
        'foil',
        'new',
        'announcement',
        'discount'
    ], 'Omit or use the `accent` skin (replaces `foil`, `new`, and `announcement`), `promo` (replaces `discount`) skin, `info` (replaces `standard`) instead'),
    /**
   * The border of the Callout
   * @deprecated The 'border' prop is no longer being supported.
   * @default standard
   */ border: deprecatedProp(PropTypes.oneOf([
        'standard',
        'none'
    ]), 'To maintain a high-quality user experience, we are no longer supporting this feature, and are not providing a direct replacement.')
};
const Callout = createComponent({
    displayName: 'Callout',
    root: 'span',
    propTypes,
    propConfig: {
        derivedProps (props) {
            const { skin = 'info', border = 'standard', variant = 'standard', size = 'standard' } = props;
            return {
                skin,
                border,
                variant,
                size
            };
        },
        classNames (_props, derivedProps) {
            const { skin, border, variant, allCaps, size } = derivedProps;
            const classNameSet = new Set([
                'swan-callout'
            ]);
            if (skin && skin !== 'standard' && skin !== 'info') classNameSet.add(`swan-callout-skin-${skin}`);
            if (border === 'none') classNameSet.add('swan-callout-borderless');
            if (variant === 'overlay') classNameSet.add('swan-callout-overlay');
            if (variant === 'inverse') classNameSet.add('swan-callout-inverse');
            if (size === 'mini') classNameSet.add('swan-callout-mini');
            if (allCaps) classNameSet.add('swan-text-all-caps');
            return classNameSet;
        }
    }
});

export { Callout };
